import React, {useState, useEffect} from "react";
import {Input} from "../ui/input";
import {Button} from "../ui/button";
import {t} from "i18next";
import {WidgetSettings} from "src/interfaces/settings";
import Icon from "../Icon";

interface EmailInputProps {
  widgetSettings: WidgetSettings;
  language: string;
  onValidEmail: (email: string) => void;
}

const EmailInput = ({onValidEmail, widgetSettings, language}: EmailInputProps) => {
  const [userEmail, setUserEmail] = useState<string>("");
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState<boolean>(false);

  const isValidEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleEmailValidation = () => {
    setHasAttemptedSubmit(true);
    if (isValidEmail(userEmail)) {
      onValidEmail(userEmail);
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
    }
  };

  useEffect(() => {
    if (userEmail && hasAttemptedSubmit) {
      setIsEmailValid(isValidEmail(userEmail));
    }
  }, [userEmail, hasAttemptedSubmit]);

  const showRedBorder = hasAttemptedSubmit && !isEmailValid;

  return (
    <div className="flex flex-col gap-6 justify-center p-4 pt-12">
      <div className="p-4 rounded-lg space-y-4" style={{backgroundColor: widgetSettings?.categoryButtonColor}}>
        <div
          className="bg-black rounded-full h-12 w-12 flex items-center justify-center"
          style={{
            backgroundColor: widgetSettings?.buttonColor,
          }}
        >
          <Icon name="assistant" iconSize="24px" />
        </div>
        {widgetSettings.langs?.[language]?.requiredEmailText && (
          <h2 className="text-lg font-semibold" style={{color: widgetSettings?.categoryButtonTextColor}}>
            {widgetSettings.langs[language].requiredEmailText}
          </h2>
        )}
      </div>
      <div className="flex flex-row justify-between">
        <Input
          type="email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          placeholder={t("EMAIL")}
          className={`${showRedBorder ? "border-red-500" : ""} rounded-r-none border-r-0`}
        />
        <Button variant="outline" className="border-l-0 rounded-l-none" onClick={handleEmailValidation}>
          Ok
        </Button>
      </div>
      {showRedBorder && <p className="text-red-500 text-sm mt-1">{t("INVALID_EMAIL")}</p>}
    </div>
  );
};

export default EmailInput;
